<template>
	<div class="wallet">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>人员信息</span>
			<div></div>
		</div>
		<div class="head">
			<div class="total" style="width: 95%;">
				<div class="active" style="display: flex; text-align: left;">
					<img v-if="list.image==null" src="../../assets/user.png" style="width: 3rem; height: 3rem; border-radius: 50%;" />
					<img v-else :src="list.image | handleUrl" style="width: 3rem; height: 3rem; border-radius: 50%;" />
					<div class="urmsg">
						<span>{{list.username}}</span>
						<span style="margin-top: 0.375rem; font-size: 0.75rem;">注册时间：{{list.create_time}}</span>
					</div>
				</div>
				<div>
					<div class="tixian" style="width: 6.3rem; margin-top: 0.4375rem;" @click="callPhone(list.tel)">
						<van-icon name="phone" />
						<span>{{list.tel}}</span>
					</div>
				</div>
			</div>
			<div class="balance" style="width: 95%;">
				<div style="width: 100%; height: 100%; border-right: 1px solid #fea451;">
					<span class="shuliang" style="font-size: 1.5625rem;">{{list.total}}</span>
					<span class="weniz">收入余额（元）</span>
				</div>
				<div style="width: 100%; height: 100%;">
					<span class="shuliang" style="font-size: 1.5625rem;">{{list.user_consumption_count}}</span>
					<span class="weniz">消费笔数（笔）</span>
				</div>
			</div>
		</div>
		<van-button type="primary" block round color="#F1452F" icon="phone" style="width: 80%; margin: 1.5rem auto;" @click="callPhone(list.tel)">拨打电话</van-button>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: ""
			}
		},
		created() {
			this.getarr();
		},
		methods: {
			getarr() {
				let that = this
				this.$axios.post(baseUrl + '/mobile/user_balance_record/shareUserBrief', {
					user_id: this.$route.query.user_id,
				}).then((res) => {
					that.list = res.data.data
				}).catch((err) => {
					console.log(err);
				})
			},
			go(e) {
				this.$router.push({
					path: '/personnelmsg',
					query: {
						user_id: e
					}
				})
			},
			// 调用拨号功能
			callPhone(phoneNumber) {
				window.location.href = 'tel://' + phoneNumber
			},
		},
	}
</script>

<style scoped>
	@import "wallet.css";

	.head {
		width: 100%;
		background-image: url("https://backstage.jbj-china.com.cn/image/img/xinyebeijingtu.png");
		background-size: 100% 100%;
		color: #fff;
		padding-bottom: 0.8rem;
	}

	.serwme {
		display: flex;
		justify-content: space-between;
		width: 85%;
		margin: 0.7rem auto;
		text-align: center;
		border-radius: 0.3rem;
		padding: 0px 1rem;
	}

	.stjl_s span {
		font-size: 1.5rem;
		display: block;
	}

	.urmsg span {
		display: block;
		font-size: 0.875rem;
		margin-left: 0.375rem;
	}

	.serwme .stjl_s {
		width: 50%;
	}

	.tieosd {
		display: flex;
		justify-content: space-between;
		margin-bottom: 0.25rem;
	}

	.tieosd>div {
		font-size: 0.8125rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/personnelmsg.vue